import { useCallback, useEffect, useRef } from 'react';

import { api, FctReport, PostActivityLogPayload } from '@/api';
import { useUser } from '@/core/user';

export const useCreateActivityLog = (report?: FctReport) => {
  const { user } = useUser();

  const postActivityLogMutation = api.fct.activityLogs.mutation.usePostActivityLogs();
  const hasActivityLogCreated = useRef(false);

  const createActivityLog = useCallback(() => {
    if (report) {
      const postActivityLogPayload: PostActivityLogPayload = {
        action: 'READ',
        actor: user.user_id,
        fullObject: {
          userSession: true,
        },
        objectDiff: null,
        relatedObjectType: 'Report',
        relatedObjectUuid: report.uuid,
        reportUuid: report.uuid,
        studyId: report.studyId ?? null,
      };

      postActivityLogMutation.mutate({ payload: postActivityLogPayload });
    }
  }, [report, user.user_id, postActivityLogMutation]);

  useEffect(() => {
    if (hasActivityLogCreated.current) {
      return;
    }

    createActivityLog();
    hasActivityLogCreated.current = true;
  }, [createActivityLog]);
};
